import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationsController::index
* @see app/Http/Controllers/AdminPanel/ApiApplicationsController.php:19
* @route '/admin-panel/api-applications'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin-panel/api-applications',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationsController::index
* @see app/Http/Controllers/AdminPanel/ApiApplicationsController.php:19
* @route '/admin-panel/api-applications'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationsController::index
* @see app/Http/Controllers/AdminPanel/ApiApplicationsController.php:19
* @route '/admin-panel/api-applications'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationsController::index
* @see app/Http/Controllers/AdminPanel/ApiApplicationsController.php:19
* @route '/admin-panel/api-applications'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationsController::index
* @see app/Http/Controllers/AdminPanel/ApiApplicationsController.php:19
* @route '/admin-panel/api-applications'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationsController::index
* @see app/Http/Controllers/AdminPanel/ApiApplicationsController.php:19
* @route '/admin-panel/api-applications'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationsController::index
* @see app/Http/Controllers/AdminPanel/ApiApplicationsController.php:19
* @route '/admin-panel/api-applications'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::show
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:21
* @route '/admin-panel/api-applications/{application}'
*/
export const show = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/admin-panel/api-applications/{application}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::show
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:21
* @route '/admin-panel/api-applications/{application}'
*/
show.url = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { application: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { application: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            application: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        application: typeof args.application === 'object'
        ? args.application.id
        : args.application,
    }

    return show.definition.url
            .replace('{application}', parsedArgs.application.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::show
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:21
* @route '/admin-panel/api-applications/{application}'
*/
show.get = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::show
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:21
* @route '/admin-panel/api-applications/{application}'
*/
show.head = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::show
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:21
* @route '/admin-panel/api-applications/{application}'
*/
const showForm = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::show
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:21
* @route '/admin-panel/api-applications/{application}'
*/
showForm.get = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::show
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:21
* @route '/admin-panel/api-applications/{application}'
*/
showForm.head = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::toggleStatus
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:67
* @route '/admin-panel/api-applications/{application}/toggle-status'
*/
export const toggleStatus = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: toggleStatus.url(args, options),
    method: 'post',
})

toggleStatus.definition = {
    methods: ["post"],
    url: '/admin-panel/api-applications/{application}/toggle-status',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::toggleStatus
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:67
* @route '/admin-panel/api-applications/{application}/toggle-status'
*/
toggleStatus.url = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { application: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { application: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            application: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        application: typeof args.application === 'object'
        ? args.application.id
        : args.application,
    }

    return toggleStatus.definition.url
            .replace('{application}', parsedArgs.application.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::toggleStatus
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:67
* @route '/admin-panel/api-applications/{application}/toggle-status'
*/
toggleStatus.post = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: toggleStatus.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::toggleStatus
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:67
* @route '/admin-panel/api-applications/{application}/toggle-status'
*/
const toggleStatusForm = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: toggleStatus.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::toggleStatus
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:67
* @route '/admin-panel/api-applications/{application}/toggle-status'
*/
toggleStatusForm.post = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: toggleStatus.url(args, options),
    method: 'post',
})

toggleStatus.form = toggleStatusForm

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::destroy
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:54
* @route '/admin-panel/api-applications/{application}'
*/
export const destroy = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin-panel/api-applications/{application}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::destroy
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:54
* @route '/admin-panel/api-applications/{application}'
*/
destroy.url = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { application: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { application: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            application: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        application: typeof args.application === 'object'
        ? args.application.id
        : args.application,
    }

    return destroy.definition.url
            .replace('{application}', parsedArgs.application.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::destroy
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:54
* @route '/admin-panel/api-applications/{application}'
*/
destroy.delete = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::destroy
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:54
* @route '/admin-panel/api-applications/{application}'
*/
const destroyForm = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AdminPanel\ApiApplicationDetailController::destroy
* @see app/Http/Controllers/AdminPanel/ApiApplicationDetailController.php:54
* @route '/admin-panel/api-applications/{application}'
*/
destroyForm.delete = (args: { application: string | number | { id: string | number } } | [application: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const apiApplications = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    toggleStatus: Object.assign(toggleStatus, toggleStatus),
    destroy: Object.assign(destroy, destroy),
}

export default apiApplications